import {
  ERROR_FETCH_LINKED_RECOARDS,
  FETCH_LINKED_RECOARDS,
} from '../actions/types';

const initialState = {
  linkedRecoards: [],
  loading: true,
};

export default function (state = initialState, action) {
  const { type, payload } = action;
  // console.log(type);
  // console.log('state', payload);
  switch (type) {
    case FETCH_LINKED_RECOARDS:
      return {
        ...state,
        linkedRecoards: payload,
        loading: false,
      };
    case ERROR_FETCH_LINKED_RECOARDS:
      return { ...state, linkedRecoards: [], loading: true };
    default:
      return state;
  }
}
